import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: 'a[plycaAnchorLink]',
  standalone: true
})
export class AnchorLinkDirective {
  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabindex = '0';
  @HostBinding('style.cursor') cursor = 'pointer';

  @HostBinding('style.text-decoration') textDecoration = 'none';

  @HostBinding('style.color') color = '#007bff';

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
  }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    this.onClick(event);
  }

  @HostListener('keydown.space', ['$event'])
  onSpace(event: KeyboardEvent): void {
    this.onClick(event);
  }
}
